class ProductFeaturesDialog extends HTMLElement {
  // 避免无限循环触发 slideTo：
  isSyncing = false;

  constructor() {
    super();
    this.swiperContainer = this.querySelector('.swiper');
    this.tabListContainer = this.querySelector('.home-shop-industry__tab-list ul');
    this.tabList = this.querySelectorAll('.home-shop-industry__tab-list ul li');
    this.triggerList = this.querySelectorAll('.home-shop-industry__content-point__trigger');


    const isMobile = `(max-width: 768px)`;
    const isMobileMQL = window.matchMedia(isMobile);
    isMobileMQL.addEventListener('change', (event) => {
      if (event.matches) {
        this.createMobileSlider();
      } else {
        this.createPcSlider();
      }
    });
    isMobileMQL.matches ? this.createMobileSlider() : this.createPcSlider();

    // Click tab.
    for (const tab of this.tabList) {
      tab.addEventListener('click', () => {
        const index = Number(tab.getAttribute('data-index'));
        this.changeTab(index);
      });
      tab.addEventListener('mouseenter', () => {
        const index = Number(tab.getAttribute('data-index'));
        this.changeTab(index);
      });
    }
    // Click trigger.
    for (const trigger of this.triggerList) {
      trigger.addEventListener('click', () => {
        this.cancelActive();
        const overlay = trigger.nextElementSibling;
        const rect = overlay.getBoundingClientRect();
        const leftOffset = rect.x;
        const rightOffset = window.innerWidth - rect.width - rect.x;
        if (leftOffset < 0) {
          overlay.style.setProperty('--overlay-offset-left', (leftOffset - 4) * -1 + 'px');
        } else if (rightOffset < 0) {
          overlay.style.setProperty('--overlay-offset-left', (rightOffset - 4) + 'px');
        }
        trigger.classList.add('active');
        trigger.parentElement?.classList.add('active');
      });
    }
    // Click other element.
    document.addEventListener('click', (e) => {
      const el = e.target.closest('.home-shop-industry__content-point');
      if (!el) {
        this.cancelActive();
      }
    });
  }

  cancelActive() {
    const trigger = this.querySelector('.home-shop-industry__content-point__trigger.active');
    trigger?.classList.remove('active');
    trigger?.parentElement?.classList.remove('active');
  }

  createMobileSlider() {
    if (this.mySwiper != null) this.mySwiper.destroy();
    this.mySwiper = new Swiper(this.swiperContainer, {
      effect: 'slide',
      speed: 500,
      spaceBetween: 12,
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      // autoHeight: true,
      allowTouchMove: true,
      observer: true,
      resizeObserver: true,
      navigation: {
        nextEl: this.nextButton || null,
        prevEl: this.prevButton || null,
      },
      breakpoints: {
        769: {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          allowTouchMove: false,
          slidesPerView: 1,
        },
      },
      on: {
        slideChange: (swiper) => {
          if (this.isSyncing) return;
          const index = swiper.activeIndex;
          if (this.mySwiper) {
            this.isSyncing = true;
            this.changeTab(index)
            this.isSyncing = false;
          }
          this.cancelActive();
        },
      },
    });
  }

  createPcSlider() {
    if (this.mySwiper != null) this.mySwiper.destroy();
    this.mySwiper = new Swiper(this.swiperContainer, {
      effect: 'fade',
      speed: 500,
      spaceBetween: 12,
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      // autoHeight: true,
      allowTouchMove: false,
      observer: true,
      resizeObserver: true,
      navigation: {
        nextEl: this.nextButton || null,
        prevEl: this.prevButton || null,
      },
      breakpoints: {
        769: {
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          allowTouchMove: false,
          slidesPerView: 1,
        },
      },
      on: {
        slideChange: (swiper) => {
          if (this.isSyncing) return;
          const index = swiper.activeIndex;
          if (this.mySwiper) {
            this.isSyncing = true;
            this.changeTab(index)
            this.isSyncing = false;
          }
        },
      },
    });
  }

  changeTab(index) {
    this.tabListContainer.querySelector('.active')?.classList.remove('active');
    const tab = this.tabList[index];
    tab?.classList.add('active');
    // Scroll into view
    if (tab.offsetLeft < this.tabListContainer.scrollLeft) {
      this.tabListContainer.scrollTo({ left: tab.offsetLeft, behavior: 'smooth' });
    }
    if ((tab.offsetLeft + tab.clientWidth) > (this.tabListContainer.scrollLeft + window.innerWidth)) {
      this.tabListContainer.scrollTo({ left: tab.offsetLeft + tab.clientWidth - window.innerWidth, behavior: 'smooth' });
    }
    if (!this.isSyncing) {
      this.isSyncing = true;
      this.mySwiper.slideTo(index);
      this.isSyncing = false;
    }
  }

  connectedCallback() {
  }
}

customElements.define('home-shop-industry', ProductFeaturesDialog);